export const USER_AUTH_KEY = 'UserAuth';
export const USER_DATA_KEY = 'UserData';
